import { render } from "./AppReviews.vue?vue&type=template&id=c53c863e&scoped=true"
import script from "./AppReviews.vue?vue&type=script&lang=js"
export * from "./AppReviews.vue?vue&type=script&lang=js"

import "./AppReviews.vue?vue&type=style&index=0&id=c53c863e&lang=scss&scoped=true"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c53c863e"]])

export default __exports__